import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M8 5h8v3H8z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "18",
  cy: "11.5",
  r: "1"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 14H8v-4h8v4zm4-4h-2v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4z"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M6 13h12v2h2v-4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4h2v-2zm12-2.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z",
  opacity: ".3"
}, "3")], 'PrintTwoTone');